<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane
      :label="major.label"
      :name="major.name"
      v-for="major in majors"
      :key="major.index"
    >
      <md-card
        md-with-hover
        style="
          width: 1184px;
          height: 200px;
          border-radius: 18px;
          margin: 20px auto;
        "
      >
        <md-card-header>
          <div class="md-title">
            <h3 style="text-align: left">
              {{ major.title }}
            </h3>
          </div>
        </md-card-header>
         
        <div class="eight-contents">
          <div class="eight-contents-one">
            <div class="eight-contents-up">
              <span>{{ major.n1 }}</span
              >个月
            </div>
            <div class="eight-contents-down">学制</div>
          </div>
          <div class="eight-contents-one">
            <div class="eight-contents-up">
              <span>{{ major.n2 }}</span
              >个
            </div>
            <div class="eight-contents-down">学习日</div>
          </div>
          <div class="eight-contents-one">
            <div class="eight-contents-up">
              <span>{{ major.n3 }}</span
              >余款
            </div>
            <div class="eight-contents-down">学习品种</div>
          </div>

          <div class="eight-contents-button">
             <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <md-button class="md-raised md-accent" style="width:200px">咨询课程信息</md-button></a>
          </div>
        </div>
      </md-card>

      <div style="width: 100%; height: 20px"></div>
      <div class="eight-words" v-html="major.text">
        <!-- <div v-html="major.text"></div> -->
      </div>

      <!-- <div class="eight-img">
        <img :src="major.img" alt="" style="width:1200px;">
      </div> -->
      <!-- <div style="width: 100%; height: 20px"></div> -->
      <div class="eight-words" v-html="major.text1">
        <!-- <div v-html="major.text"></div> -->
      </div>
      <div class="eight-img">
        <el-image :src="major.img"></el-image>
        
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1",
      majors: [
        {
          label: "烘焙全能班",
          name: "1",
          title: "烘焙甜点全能班",
          n1: "15",
          n2: "1200",
          n3: "600",
          more: "",
          text: "零基础<span style='color:#000'>全品种</span>学习班制，打造<span style='color:#000'>高技能创就业人才</span>。",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m1.jpg",
          text1:
            "打造<span style='color:#000'>国际化</span>与<span style='color:#000'>本土化</span>相融合的教学课程体系。",
        },
        {
          label: "烘焙金领班",
          name: "2",
          title: "烘焙甜点金领班",
          n1: "9",
          n2: "720",
          n3: "300",
          more: "",
          text: "以培养<span style='color:#000'>高级西点人才、行政总厨、厨师长</span>等<span style='color:#000'>技术型人才</span>为目标",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m2.jpg",
        },
        {
          label: "烘焙精英班",
          name: "3",
          title: "烘焙甜点精英班",
          n1: "6",
          n2: "480",
          n3: "200",
          more: "",
          text: "培养与市场接轨，有<span style='color:#000'>自主创作能力</span>的<span style='color:#000'>西点达人</span>。就业方向:<span style='color:#000'>大型酒店，法国餐厅和连锁西点饼房</span>",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m3.jpg",
        },
        {
          label: "烘焙经典班",
          name: "4",
          title: "烘焙甜点经典班",
          n1: "3",
          n2: "240",
          n3: "120",
          more: "",
          text: "培养<span style='color:#000'>大型饼房，酒店餐饮厨师长、店长</span>等人才",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m4.jpg",
        },
        {
          label: "西餐金领班",
          name: "5",
          title: "西餐料理金领班",
          n1: "9",
          n2: "720",
          n3: "300",
          more: "",
          text: "<span style='color:#000'>大量操作实训</span>，包含<span style='color:#000'>开胃菜、主菜、三明治、披萨、酱汁和意面</span>的制作；让您能熟练运用<span style='color:#000'>原料知识</span>。毕业后，知识丰富技能娴熟可任职<span style='color:#000'>大酒店厨房及西餐连锁店</span>。",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m5.jpg",
        },
        {
          label: "西餐精英班",
          name: "6",
          title: "西餐料理精英班",
          n1: "6",
          n2: "480",
          n3: "240",
          more: "",
          text: "以培养现代餐饮行业烹饪<span style='color:#000'>主厨、大厨、厨师长</span>为目标、培养学生的实践操作能力、不同档次<span style='color:#000'>宴席设计和制作人员</span>",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m6.jpg",
        },
        {
          label: "咖啡饮品",
          name: "7",
          title: "咖啡饮品专业",
          n1: "1",
          n2: "20",
          n3: "50",
          more: "",
          text: "让您掌握娴熟的咖啡煮制技能：<span style='color:#000'>纯品咖啡、花式咖啡、咖啡拉花</span>等，对咖啡豆具有详细的了解和认知；培养您成为<span style='color:#000'>职业的领头人、咖啡管理与制作的人才</span>",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m7.jpg",
        },
        {
          label: "精品调酒",
          name: "8",
          title: "精品调酒专业",
          n1: "2",
          n2: "160",
          n3: "120",
          more: "",
          text: "培养具有<span style='color:#000'>自主研发能力，高水平,高技能</span>的学子。适合<span style='color:#000'>零基础</span>、热爱西点行业，注重技能的<span style='color:#000'>复合型</span>人才",
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/m8.jpg",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs__item {
  font-size: 24px;
  font-weight: 600;
}
/deep/ .el-tabs__item:hover {
  color: #8d6e63;
}
/deep/ .el-tabs__item.is-active {
  color: #8d6e63;
}
/deep/ .el-tabs__active-bar {
  height: 4px;
  background-color: #8d6e63;
}
/deep/ .el-tabs__item {
  color: #838383;
  height: 53px;
  line-height: 53px;
  padding: 0 18px;
}
.md-card.md-with-hover {
  cursor: auto;
}
.eight-title {
  width: 100%;
  font-size: 28px;
  color: #000;
  font-weight: 600;
  text-align: left;
}
.eight-contents {
  width: 100%;
  height: 120px;
  padding: 10px 0;
  .eight-contents-one {
    float: left;
    padding: 0 20px;
    text-align: center;
    color: #838383;
    .eight-contents-up {
      height: 70px;
      span {
        font-size: 56px;
        font-weight: 600;
        background: linear-gradient(45deg, #ff9fe1, #ff3d00);
        -webkit-background-clip: text;
        color: transparent;
        -webkit-text-fill-color: transparent;
        text-fill-color: transparent;
      }
    }

    .eight-contents-down {
      height: 30px;
    }
  }
  .eight-contents-button {
    float: right;
    padding: 37px 20px 0px 20px;
    height: 90px;
  }
}
.eight-words {
  font-size: 1.5em;
  color: #838383;
  font-weight: 600;
  text-align: left;
  padding: 0 0 15px 0;
  span {
    color: #000;
  }
}
.poptip2 {
  width: 320px;
  height: 260px;
  padding: 10px 10px 0 10px;
}
.eight-img {
  text-align: left;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
</style>